import React from "react";

const ContactUsSection = () => {
  return (
    <div className="contact-us-section section-padding fix">
      <div className="contact-box-wrapper style1">
        <div className="container">
          <div className="row gy-4">

            {/* Address */}
            <div className="col-md-6 col-xl-4">
              <div className="contact-box style1">
                <div className="contact-icon">
                  <img src="/assets/img/icon/location.png" alt="icon" />
                </div>
                <h3 className="title">Address</h3>
                <p> Shop No: G/17, Devpreet Complex, Visat Gandhinagar Highway Road, opposite IIT Engineering College, Motera,
                     Ahmedabad, Gujarat 380005</p>
              </div>
            </div>

            {/* Email */}
            <div className="col-md-6 col-xl-4">
              <div className="contact-box style1">
                <div className="contact-icon">
                  <img src="/assets/img/icon/gmail.png" alt="icon" />
                </div>
                <span className="email_name">bhargav.jayswal.bj@gmail.com</span>
                <p>Email us anytime for any kind of query.</p>
              </div>
            </div>

            {/* Phone */}
            <div className="col-md-6 col-xl-4">
              <div className="contact-box style1">
                <div className="contact-icon">
                  <img src="/assets/img/icon/phone.png" alt="icon" />
                </div>
                <h3 className="title">+91 78743 43757</h3>
                <p>For Catering & Event Quries</p>
              </div>
            </div>

            {/* Opening Hour */}
            {/* <div className="col-md-6 col-xl-3">
              <div className="contact-box style1">
                <div className="contact-icon">
                  <img src="/assets/img/icon/clock.png" alt="icon" />
                </div>
                <h3 className="title">Opening Hour</h3>
                <p>Sun-Sat: 10 AM – 11 PM</p>
              </div>
            </div> */}

          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUsSection;
